/**
 * Convert a string to a URL-friendly slug
 * @param {string} text - The text to slugify
 * @returns {string} - URL-friendly slug
 */
export const slugify = (text) => {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    // Replace Romanian special characters
    .replace(/ă/g, 'a')
    .replace(/â/g, 'a')
    .replace(/î/g, 'i')
    .replace(/ș/g, 's')
    .replace(/ț/g, 't')
    // Replace spaces with hyphens
    .replace(/\s+/g, '-')
    // Remove special characters
    .replace(/[^\w-]+/g, '')
    // Replace multiple hyphens with single hyphen
    .replace(/--+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

/**
 * Generate announcement URL with ID at the beginning
 * @param {number} id - Announcement ID
 * @param {string} title - Announcement title
 * @param {string} category - Main category
 * @param {string} subcategory - Subcategory (optional)
 * @param {string} publishDate - Publish date (optional, not used in new format)
 * @returns {string} - URL path for announcement
 */
export const getAnnouncementUrl = (id, title, category = '', subcategory = '', publishDate = null) => {
  const titleSlug = slugify(title);
  const categorySlug = slugify(category);
  const subcategorySlug = slugify(subcategory);
  
  // Start with /announcement/ID
  let urlParts = [`/announcement/${id}`];
  
  if (categorySlug) {
    urlParts.push(categorySlug);
  }
  
  if (subcategorySlug) {
    urlParts.push(subcategorySlug);
  }
  
  if (titleSlug && titleSlug.length >= 2) {
    urlParts.push(titleSlug);
  }
  
  return urlParts.join('/');
};

/**
 * Extract ID from URL
 * @param {string} urlPath - Full URL path
 * @returns {number|null} - Extracted ID or null
 */
export const extractIdFromSlug = (urlPath) => {
  if (!urlPath) return null;
  
  // Match pattern: /announcement/ID/...
  const match = urlPath.match(/\/announcement\/(\d+)/);
  if (match && match[1]) {
    return parseInt(match[1], 10);
  }
  
  return null;
};
